import moment from 'moment';
import { DAYS_OBJECT } from '@/utils/consts';
import { hDeepCopy, hFixDaysOrder, hPrepareAndArrangeTheDaysReceivedFromApi } from '@/utils/helpers';

export default {
  name: 'WorkHoursOperationForm',

  props: {
    agentDetails: {
      type: Object,
      default: (() => {}),
    },
    projectDetails: {
      type: Object,
      default: (() => {}),
    },
    elementDetails: {
      type: Object,
      default: (() => {}),
    },
    type: {
      type: String,
      default: 'agent',
    },
  },

  data() {
    return {
      workDays: DAYS_OBJECT,
      updatedData: {
        work_day: '',
        work_time_begin: '',
        work_time_end: '',
        d1_begin: '',
        d1_end: '',
        d2_begin: '',
        d2_end: '',
        d3_begin: '',
        d3_end: '',
        d4_begin: '',
        d4_end: '',
        d5_begin: '',
        d5_end: '',
        d6_begin: '',
        d6_end: '',
        d0_begin: '',
        d0_end: '',
      },
      rules: {
      },
    };
  },

  watch: {
    agentDetails(newVal) {
      this.setInitialEditorData(newVal);
    },
    projectDetails(newVal) {
      this.setInitialEditorData(newVal);
    },
    'updatedData.work_day': function (newVal, oldVal) {
      if (newVal.length < oldVal.length) {
        const deletedDay = (oldVal.filter(element => !newVal.includes(element)));
        this.clearWorhHoursForSpecificDay(deletedDay);
      }
    },
  },

  async created() {
    this.setInitialEditorData(this.type === 'agent'
      ? this.agentDetails
      : this.type === 'element'
        ? this.elementDetails
        : this.projectDetails);
  },

  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'client/project/agents/updateAgent',
        'client/project/updateProject',
        'client/project/agents/getList',
        'client/project/alternativeMenu/updateElement',
      ]);
    },
  },

  methods: {
    clearWorhHoursForSpecificDay(dayNumber) {
      this.updatedData[`d${dayNumber}_begin`] = null;
      this.updatedData[`d${dayNumber}_end`] = null;
    },
    setInitialEditorData(updatedElementDetails) {
      let copyDetails = hDeepCopy(updatedElementDetails);
      this.updatedData = Object.assign(
        {},
        copyDetails,
        ...Object.keys(copyDetails).map(value => value in copyDetails && { [value]: copyDetails[value] }),
      );
      this.updatedData.work_day = hPrepareAndArrangeTheDaysReceivedFromApi(copyDetails.work_day);
    },
    fixDaysOrderAfterSelect() {
      this.updatedData.work_day = hFixDaysOrder(this.updatedData.work_day);
    },
    async submitForm() {
      const paramsToUpdate = {
        work_day: this.updatedData.work_day,
        ...this.__addUpdateParamIfFilled('work_time_begin'),
        ...this.__addUpdateParamIfFilled('work_time_end'),
        ...this.__addUpdateParamIfFilled('d1_begin'),
        ...this.__addUpdateParamIfFilled('d1_end'),
        ...this.__addUpdateParamIfFilled('d2_begin'),
        ...this.__addUpdateParamIfFilled('d2_end'),
        ...this.__addUpdateParamIfFilled('d3_begin'),
        ...this.__addUpdateParamIfFilled('d3_end'),
        ...this.__addUpdateParamIfFilled('d4_begin'),
        ...this.__addUpdateParamIfFilled('d4_end'),
        ...this.__addUpdateParamIfFilled('d5_begin'),
        ...this.__addUpdateParamIfFilled('d5_end'),
        ...this.__addUpdateParamIfFilled('d6_begin'),
        ...this.__addUpdateParamIfFilled('d6_end'),
        ...this.__addUpdateParamIfFilled('d0_begin'),
        ...this.__addUpdateParamIfFilled('d0_end'),
      };

      if (this.type === 'agent') {
        await this.$store.dispatch('client/project/agents/updateAgent', {
          ...paramsToUpdate,
          agent: this.agentDetails.uuid,
        });
      } else if (this.type === 'project') {
        await this.$store.dispatch('client/project/updateProject', {
          ...paramsToUpdate,
          project: this.projectDetails.uuid,
        });
      } else {
        await this.$store.dispatch('client/project/alternativeMenu/updateElement', {
          ...paramsToUpdate,
          elementMenu: this.elementDetails.id,
        });
      }
      this.$message({
        type: 'success',
        message: `Edycja godzin pracy dla
          ${this.type === 'agent' ? 'agenta' : this.type === 'project' ? 'projektu' : 'elementu menu'} przebiegła pomyślnie`,
      });
      this.$emit('refresh');
      this.closeModal();
    },
    closeModal() {
      this.$emit('closeModal');
    },
    __addUpdateParamIfFilled(param) {
      return ({ [param]: this.updatedData[param] ? moment(this.updatedData[param], 'HH:mm:ss').format('HH:mm:ss') : null }
      );
    },
  },
};
